// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V7H2V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M2 9H22V22L2 22V9ZM18 14.5V12.5H6V14.5L18 14.5ZM14 18.5V16.5L6 16.5V18.5L14 18.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-form-filled')
export default class FormFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'form-filled',
    }
  }
}
